import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { PAYMENTS_CLAIMS_PAID_DATA_API_URL, CLAIMS_YIELD_ALL_PASSES_METRICS_API_URL,
   SERVICE_TYPE_PASS_WISE_METRICS_API_URL ,
   PAYMENTS_CLAIMS_SUMMARY_API_URL,
    PAYMENTS_CLAIMS_SERVICE_PATH_DOP,
    CLAIMS_BIFURCATE_MERICS,
    PAYMENTS_BULKTINS_CLAIMS_SERVICE_PATH_DOP,
    CLAIMS_BULKTINS_BIFURCATE_MERICS,
    SERVICE_TYPE_BULKTINS_PASS_WISE_METRICS_API_URL,
    CLAIMS_YIELD_BULKTINS_ALL_PASSES_METRICS_API_URL,
    PAYMENTS_BULKTINS_CLAIMS_SUMMARY_API_URL,
    PAYMENTS_BULKTINS_CLAIMS_PAID_DATA_API_URL
  } from './apiUrlConstants';
import { getPaymentsClaimsPaidData } from './payments.service.mock';
import { getJobId, queueJobPolling } from '@src/utility/CommonBulkPoll';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const _httpService = new HttpService();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

const tinGroupId = sessionStorage.getItem('tinGroupId')
  ? sessionStorage.getItem('tinGroupId')
  : '';

type PollBulkJobOptions = { onStop?: (stopFn: () => void) => void };
async function pollBulkJob<T = unknown>(
  endpoint: string,
  payload: Record<string, unknown>,
  options?: PollBulkJobOptions
): Promise<T> {
  const jobIdResponse = await getJobId(endpoint, payload);
  const jobId = jobIdResponse.Data.JobId;
  return new Promise<T>((resolve, reject) => {
    queueJobPolling(
      jobId,
      {
        onInProgress: () => {
},
        onCompleted: (result) => {
resolve(result as T);
        },
        onFailed: (errorMessage) => {
          console.error('Bulk Polling - Job failed:', errorMessage);
          reject(new Error(errorMessage));
        },
        onStatusUpdate: (statusResponse) => {
},
      },
      '/job-status/result',
      1000,
      undefined,
      false
    ).then((cleanup) => {
      if (options && typeof options.onStop === 'function') {
        options.onStop(cleanup);
      }
    });
  });
}

export const getDOPClaimsSummaryDataRequest = async (payload: any) => {
  const url = PAYMENTS_CLAIMS_SERVICE_PATH_DOP;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData?.Data;
  } catch {
    return null;
  }
};

export const getClaimsBifurcateMetricsDataRequest = async (payload: any) => {
  const url = CLAIMS_BIFURCATE_MERICS;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData?.Data;
  } catch {
    return null;
  }
};

export const getPaymentsClaimPaidDataRequest = async (payload: any) => {
  const url = PAYMENTS_CLAIMS_PAID_DATA_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    // const responseData: any = await getPaymentsClaimsPaidData();
    return responseData?.Data;
  } catch {
    return null;
  }
};

export const getPaymentsClaimsSummaryDataRequest = async (payload: any) => {
  const url = PAYMENTS_CLAIMS_SUMMARY_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData?.Data;
  } catch {
    return null;
  }
}

export const getClaimsYieldAllPassesMetricsDataRequest = async (payload: any) => {
  const url = CLAIMS_YIELD_ALL_PASSES_METRICS_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData?.Data;
  } catch {
    return null;
  }
};

export const getServiceTypePassWiseMetricsDataRequest = async (payload: any) => {
  const url = SERVICE_TYPE_PASS_WISE_METRICS_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData?.Data;
  } catch {
    return null;
  }
};
//.      ------ --- --------    Bulk Polling.   ---------------

export const getDOPClaimsSummaryDataRequestBulk = async (payload: any,
  options?: { onStop?: (stopFn: () => void) => void }) : Promise<any>=> {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = PAYMENTS_BULKTINS_CLAIMS_SERVICE_PATH_DOP

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );
    return pollingResult;
  } catch (error) {
    console.error('Error fetching DOP Claims summary Details in bulk:', error);
    throw error;
  }
};

export const getClaimsBifurcateMetricsDataRequestBulk = async (payload: any,
  options?: { onStop?: (stopFn: () => void) => void }):Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = CLAIMS_BULKTINS_BIFURCATE_MERICS;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );
    
    return pollingResult;
  } catch (error) {
    console.error('Error fetching claim bifurcate metrics Details in bulk:', error);
    throw error;
  }
};

export const getPaymentsClaimPaidDataRequestBulk = async (payload: any,
  options?: { onStop?: (stopFn: () => void) => void }):Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = PAYMENTS_BULKTINS_CLAIMS_PAID_DATA_API_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );
    return pollingResult;
  } catch (error) {
    console.error('Error fetching claim paid Details in bulk:', error);
    throw error;
  }
};

export const getPaymentsClaimsSummaryDataRequestBulk = async (payload: any,
  options?: { onStop?: (stopFn: () => void) => void }):Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = PAYMENTS_BULKTINS_CLAIMS_SUMMARY_API_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );
    return pollingResult;
  } catch (error) {
    console.error('Error fetching claim summary metrics Details in bulk:', error);
    throw error;
  }
}

export const getClaimsYieldAllPassesMetricsDataRequestBulk = async (payload: any,
  options?: { onStop?: (stopFn: () => void) => void }):Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = CLAIMS_YIELD_BULKTINS_ALL_PASSES_METRICS_API_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );
    return pollingResult;
  } catch (error) {
    console.error('Error fetching claim yield all pass metrics Details in bulk:', error);
    throw error;
  }
};

export const getServiceTypePassWiseMetricsDataRequestBulk = async (payload: any,
  options?: { onStop?: (stopFn: () => void) => void }):Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = SERVICE_TYPE_BULKTINS_PASS_WISE_METRICS_API_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );
    return pollingResult;
  } catch (error) {
    console.error('Error fetching service type metrics Details in bulk:', error);
    throw error;
  }
};